import React from "react";
import ContactMain from "./ContactMain";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import NpfTracking from "../../components/NpfTracking";
import NpfWidget from "../../components/NpfWidget";

import footerLogo from "../../assets/images/logos/footer-logo.png";

const ContactPage = () => {
  return (
    <>
      {/* NoPaperForms: dynamic tracking + enquiry widget */}
      <NpfTracking />
      <NpfWidget />
      <Header parentMenu="contact" topbarEnable="enable" />
      <ContactMain />
      <Footer footerLogo={footerLogo} />
    </>
  );
};

export default ContactPage;
